import { Injectable } from '@angular/core';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class AnswerProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    /**
     * Find all FeedbackAnswerSurvey for a Feedback
     */
    public findAllByQuestionId(feedbackId: number, questionId: number): Observable<FeedbackAnswerSurvey[]> {
        return this.api.call('get',`feedback/${feedbackId}/question/${questionId}/answers`, {}, this.currentUser.getAccessToken())
          .pipe(map((data) => data.map((a: any) => new FeedbackAnswerSurvey(a.id, a.label, a.data, a.sortOrder, a.nextQuestionId, a.questionAnswerId))));
    }
}

export class FeedbackAnswerSurvey {
    public id: number;
    public label: string;
    public data: string;
    public sortOrder: number;
    public nextQuestionId: number;
    public questionAnswerId: number;
    public userData?: string;

    constructor(id: any, label: any, data: any, sortOrder: any, nextQuestionId: any, questionAnswerId: any) {
        this.id = id;
        this.label = label;
        this.data = data;
        this.nextQuestionId = nextQuestionId;
        this.sortOrder = sortOrder;
        this.questionAnswerId = questionAnswerId;
    }
}
